import { Component, OnInit, HostListener } from "@angular/core";
import { Router } from "@angular/router";

import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { RequestService } from "../../services/request.service";
import { SidebarService } from "../../services/sidebar.service";
import { ThemeService } from "../../services/theme.service";

@Component({
  selector: "app-full-layout",
  templateUrl: "./full.component.html",
  styleUrls: ["./full.component.scss"],
})
export class FullComponent implements OnInit {
  public loginLoading = false;
  color = "red";
  showSettings = false;
  showRtl = false;

  public innerWidth: any;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public router: Router,
    public requestServ: RequestService,
    public sidebarService: SidebarService,
    public themeService: ThemeService
  ) {}

  ngOnInit() {
    if (this.router.url === "/") {
      this.router.navigate(["/dashboard/dashboard"]);
    }
    this.requestServ.dimensionPantalla();
    this.handleLayout();
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    // El teclado virtual del móvil dispara resize cambiando solo el ALTO del viewport.
    // Si solo re-aplicáramos el layout ahí, se cerraría el menú móvil (setMobileOpen(false))
    // apenas el usuario toca un input (p. ej. el buscador de empresa). Por eso solo
    // reaccionamos cuando cambia el ANCHO (cruce real de breakpoint), no el alto.
    if (window.innerWidth === this.innerWidth) return;
    this.handleLayout();
  }

  get isMobile(): boolean {
    return this.innerWidth < 768;
  }

  get isMobileOpen(): boolean {
    return this.sidebarService.getMobileStatus();
  }

  toggleSidebar() {
    if (this.isMobile) {
      this.sidebarService.setMobileOpen(!this.sidebarService.getMobileStatus());
      return;
    }
    this.sidebarService.showMinisidebar = !this.sidebarService.showMinisidebar;
  }

  toggleMobileMenu() {
    this.sidebarService.setMobileOpen(!this.sidebarService.getMobileStatus());
  }

  handleLayout() {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 768) {
      this.sidebarService.showMinisidebar = false;
      this.sidebarService.setMobileOpen(false);
    } else if (this.innerWidth < 1170) {
      this.sidebarService.showMinisidebar = true;
    } else {
      this.sidebarService.showMinisidebar = false;
    }
  }

  closeSidebar(ev?: MouseEvent) {
    ev?.stopPropagation?.();
    if (!this.isMobile) return;
    if (!this.sidebarService.getMobileStatus()) return;
    this.sidebarService.setMobileOpen(false);
  }
}
